export type ClassValue = string | number | false | null | undefined | ClassValue[];

/**
 * Minimal class-name joiner. Deliberately not `clsx`/`tailwind-merge`: components in this
 * codebase compose their own classes and never need conflict resolution, so a dependency
 * would buy nothing.
 */
export function cn(...values: ClassValue[]): string {
  const out: string[] = [];
  for (const value of values) {
    if (!value && value !== 0) {
      continue;
    }
    if (Array.isArray(value)) {
      const nested = cn(...value);
      if (nested) {
        out.push(nested);
      }
    } else {
      out.push(String(value));
    }
  }
  return out.join(" ");
}
